import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-public-activity-card',
  components: {},
})
export default class PublicActivityCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;
  @Prop(String) readonly type: string;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  public formatPrice(value: string) {
    return ToolsHelper.formatPrice(value);
  }
  get editActivatedAndShown(): boolean {
    const action = this.item?.actions?.edit;
    return action?.show && action?.activated;
  }

  get detailsActivatedAndShown(): boolean {
    const action = this.item?.actions?.details;
    return action?.show && action?.activated;
  }

  get publicDetailsActivatedAndShown(): boolean {
    const action = this.item?.actions?.publicDetails;
    return action?.show && action?.activated;
  }

  get short_description(): string {
    const clamp = '...';
    const length = 80;
    return this.item.short_description.length > length
      ? this.item.short_description.slice(0, length) + clamp
      : this.item.short_description;
  }

  get startDate(): string {
    if (this.item.start_date) {
      return moment(this.item.start_date, 'YYYY-MM-DD')
        .locale('fr')
        .format('ddd DD/MM/YYYY');
    }
    return null;
  }

  get endDate(): string {
    if (this.item.end_date) {
      return moment(this.item.end_date, 'YYYY-MM-DD')
        .locale('fr')
        .format('ddd DD/MM/YYYY');
    }
    return null;
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.item.activities[this.currentImgField];
  }
}
